module.exports = __webpack_public_path__ + "img/img75.4ac96d9c.png";